import { Badge, Button } from "@coval/ui"

interface MetricFilterModeToggleProps {
  mode: "presence" | "value"
  onModeChange: (mode: "presence" | "value") => void
  presenceCount: number
  valueCount: number
}

export function MetricFilterModeToggle({
  mode,
  onModeChange,
  presenceCount,
  valueCount,
}: MetricFilterModeToggleProps) {
  return (
    <div className="border-b border-coval-border p-2">
      <div className="grid grid-cols-2 gap-2" aria-label="Metric filter mode">
        <Button
          variant="secondary"
          active={mode === "presence"}
          aria-pressed={mode === "presence"}
          onClick={() => onModeChange("presence")}
        >
          Has Metric
          {presenceCount > 0 && <Badge size="status">{presenceCount}</Badge>}
        </Button>
        <Button
          variant="secondary"
          active={mode === "value"}
          aria-pressed={mode === "value"}
          onClick={() => onModeChange("value")}
        >
          Value
          {valueCount > 0 && <Badge size="status">{valueCount}</Badge>}
        </Button>
      </div>
    </div>
  )
}
